import i18n from "../../plugins/I18nPlugin";

export function numberHigherRule(
  higherValue: number,
  message = "components.thg.ThgQuoteUpdateDialog.ruleHigher"
): (value: any) => boolean | string {
  return (value) => value >= higherValue || String(i18n.tc(message)) + " " + higherValue;
}

export function numberHigherOrNullOrUndefinedRule(
  higherValue: number,
  message = "components.thg.ThgQuoteUpdateDialog.ruleHigher"
): (value: any) => boolean | string {
  return (value) =>
    value === null || value === undefined || value >= higherValue || String(i18n.tc(message)) + " " + higherValue;
}

/**
 * Strictly-greater rule (`>`) with a blank message, matching the `requiredRuleSilent` convention:
 * for carrier fields whose error is surfaced elsewhere (e.g. an alert component). Coerces the
 * untyped Vuetify field value before comparing, so non-numeric input (including NaN) fails.
 */
export function numberStrictlyHigherRuleSilent(higherValue: number): (value: any) => boolean | string {
  return (value) => Number(value) > higherValue || " ";
}
